import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';
import { isEntityPresentSelector } from 'components/Common/Data/DataFetcherEntitiesHelper';
import { getCompositeSchemaKey } from 'components/Common/Data/DataFetcherSuperUtils';
import {
  ENTITY_LEAD_SOURCES,
  ENTITY_LEAD_SOURCES_LIST,
  leadSourcesSchema,
  leadSourcesListSchema,
} from 'schema/LeadSourceSchema';
import { getEntities } from 'resources/EntityData';
import { EmptyObject } from 'resources/EmptyDefaults';
import LeadSourcesApi from './Api';

export const NEW_FROM_LEAD_SOURCE_SETTINGS = 'new lead source - lead source page';
export const NEW_FROM_CALL_TRACKING_NUMBERS_SETTINGS = 'new lead source - call tracking settings page';
export const NEW_FROM_JOB_DETAILS = 'new lead source - job details';
export const NEW_FROM_ESTIMATE_DETAILS = 'new lead source - estimate details';
export const NEW_FROM_CUSTOMER_DETAILS = 'new lead source - customer details';
export const NEW_FROM_NEW_JOB = 'new lead source - new job page';
export const NEW_FROM_NEW_ESTIMATE = 'new lead source - new estimate page';
export const NEW_FROM_NEW_CUSTOMER = 'new lead source - new customer dialog';
export const NEW_FROM_NEW_CALL = 'new lead source - new call page';
export const NEW_FROM_LEAD_DETAILS = 'new lead source - lead details page';

export const FOR_NEW_CALL = 'new call';
export const FOR_NEW_CUSTOMER = 'new customer';
export const FOR_NEW_JOB = 'new job';
export const FOR_NEW_ESTIMATE = 'new estimate';
export const FOR_ESTIMATE = 'estimate';
export const FOR_JOB = 'job';
export const FOR_CUSTOMER = 'customer';
export const FOR_CALL_TRACKING_NUMBERS_SETTINGS = 'call tracking number settings';
export const FOR_CUSTOMER_LIST = 'customer list';
export const FOR_CUSTOMER_JOB_LIST = 'customer - job list';
export const FOR_CUSTOMER_ESTIMATE_LIST = 'customer - estimate list';
export const FOR_LEAD_DETAILS = 'lead details';

export const LEAD_SOURCE_NAME_SPACE = 'lead_source';
export const LEAD_SOURCES_PAGINATION_ID = 'lead_sources';

export const getLeadSource = createSelector(
  getEntities,
  (_state, { uuid } = {}) => uuid,
  (state, { uuid } = {}) =>
    isEntityPresentSelector(state, {
      namespace: ENTITY_LEAD_SOURCES,
      key: uuid,
    }),
  (entities, uuid, isLeadSourcePresent) => {
    if (!isLeadSourcePresent) return EmptyObject;
    return denormalize(uuid, leadSourcesSchema, entities);
  }
);

const getLeadSources = createSelector(
  getEntities,
  (_state, { paginationData } = {}) => getCompositeSchemaKey(paginationData),
  (state, { paginationData } = {}) =>
    isEntityPresentSelector(state, {
      namespace: ENTITY_LEAD_SOURCES_LIST,
      key: getCompositeSchemaKey(paginationData),
    }),
  (entities, schemaKey, isLeadSourcesListPresent) => {
    if (!isLeadSourcesListPresent) return EmptyObject;
    return denormalize(schemaKey, leadSourcesListSchema, entities) || EmptyObject;
  }
);

export const fetchLeadSources = {
  fetchingApiFunc: LeadSourcesApi.index,
  paramsFromProps: ({ paginationData, searchQuery } = {}) => [{ ...paginationData, q: searchQuery }],
  schema: leadSourcesListSchema,
  selector: getLeadSources,
};

export const fetchFranchiseLeadSources = {
  ...fetchLeadSources,
  paramsFromProps: ({ paginationData, searchQuery } = {}) => [{ ...paginationData, q: searchQuery, for_franchise: true }],
}
export const fetchLeadSource = {
  fetchingApiFunc: LeadSourcesApi.show,
  paramsFromProps: ({ uuid }) => [{ uuid }],
  schema: leadSourcesSchema,
  selector: getLeadSource,
};
